import { CatchText, Content, ContentTitle, RedTitle, SinceText } from '../components/atoms/SideLayoutObjs';
import { BackImageLayer } from '../components/layout/BackgroundLayer';
import { SideLayout } from '../components/layout/SideLayout';

export const ServiceBackLayer = () => {
	return (
		<div>
			<BackImageLayer />
		</div>
	);
};

export const ServicePage = () => {
	return (
		<div>
			<SideLayout>
				<RedTitle>Service</RedTitle>
				<CatchText>招待制ビジネス教育機関</CatchText>
				<ContentTitle>ALLROUNDER</ContentTitle>
				<SinceText>Since 2012</SinceText>

				<Content>
					<p>
						「最高の人材を作る」をテーマに大学生・社会人に向けて経営・マーケティング・PR・ファイナンスを提供している教育機関。
					</p>
					<p>
						プロジェクトの企画・運営を通じて自己実現できる人材育成を目指し、ヒト・場所・育成を軸に優秀な人材が育つ環境を目指す。
					</p>
					<p>
						東京・大阪・広島・福岡・北海道を中心に活動、2020年新型コロナウイルスを機会に、リアル中心だった活動から、
						オンラインを大幅に強化し、その結果全国から参加者が増えより拡大に成功した。さらにメタバースオフィスを立ち上げ
						今後グローバル展開を積極的に力を入れる
					</p>
					<p>2012年から10年、延べ5000名を超えるメンバーを指導。</p>
				</Content>
				<br />
				<CatchText>18歳以下から25歳限定</CatchText>
				<ContentTitle>キャリアバー</ContentTitle>

				<Content>
					<p>就職をミスマッチングした人に対し３つの問題に対し課題解決していく企画です。</p>

					<p>
						１，就職して合わなかった。ミスマッチング
						<br />
						・業種が好きになれない。長くやれる自信がない、頑張れないなど
						<br />
						・興味のない種目で全国大会に出るようなもの
					</p>

					<p>
						２，就職先のレベルが合わずにミスマッチング
						<br />
						・成長できると想い、就職したものの望むスキルアップが得られない環境
						<br />
						・意識が合わない、モヤモヤする、物足りない
					</p>

					<p>
						３，どこに就職していいのか分からない。
						<br />
						・やりたいことが分からない、
					</p>

					<p>
						弊社の、14年間6000名で多くのキャリア支援をしてきた実績や経験、
						ノウハウがあれば、３つの問題解決は自信があります。まずは、
						気軽な場が必要だと考え、キャリアセミナーやエージェントとか相談所みたいな
						ことではなく、カジュアルに相談できる機会や、いろんな業界とのネットワークを
						構築する機会が必要と考え、キャリアバーが誕生しました。これをスタートに 今後展開できればなと考えています。
					</p>
				</Content>
				<br />
				<CatchText>CSR活動</CatchText>
				<ContentTitle>TEAM 31</ContentTitle>

				<Content>
					<p>
						大学生のダントツNo.１で多い悩み。 やりたいことがない。というシンプルな問題が
						最も多い。この状態がブレた状態で社会に出ても ミスマッチング、仮に社会的成功を収めても
						燃え尽き症候群の原因にもなります。 成功と幸せは別です。
					</p>
					<p>
						やりたいことの見つけ方をそもそも分からない。 機会がないという声が圧倒的に多く、
						31歳人生設計７つのコピペという活動を 2022年から活動しています。
					</p>
					<p>
						東大500名京大300名が動員。 発売初日からソールドアウトが当たり前になり
						時代のクリティカルな「やりたいことがない」 という問題を解決していくプロジェクトです。
					</p>
				</Content>
			</SideLayout>
		</div>
	);
};
